var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxOutlineBlankIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 19",
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 17,
  height: 17,
  rx: 2,
  transform: "translate(0 .833)",
  fill: "#FFF",
  stroke: "#4A4A4A",
  fillRule: "evenodd"
})));
export default SvgCheckboxOutlineBlankIconcom;